import Common from "./Common";
import Login from "./Login";
import Signup from "./Signup";

const TRANSLATIONS_EN = {
  Common,
  Login,
  Signup,
};
export default TRANSLATIONS_EN;
